import { useState, useEffect, useContext } from 'react';
import { FundContext } from '../FundPage';
// import { Trash2 } from 'react-feather';
import { differenceInMonths, differenceInYears, format, formatDuration } from "date-fns";
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailField from '../../../Shared/DetailSection/DetailField';
import Table from '../../../../components/Table/Table';
import FlexWrapper from '../../../FlexWrapper';
import "../FundPage.scss"


const FundPersonnel = ({ }) => {
    const { fund, setFund, editMode, setSelectedTab } = useContext(FundContext)
    const [personExpanded, setPersonExpanded] = useState(null)

    useEffect(() => {
        setSelectedTab("Key Personnel")
    }, [])


    function updateKeyPersonnel(newValue, property, idx) {
        if (property === "deleted" && newValue === true && fund.personnel[idx].id === null) {
            let newPersonnel = [...fund.personnel.filter((person, i) => i !== idx)]
            const newObj = { ...fund, personnel: newPersonnel }
            setFund(newObj)
            setPersonExpanded(newPersonnel.length - 1)
            return;
        }
        // save temporary updates
        let newPersonnel = []
        fund.personnel.forEach((person, i) => {
            if (i === idx) {
                newPersonnel.push({ ...person, [property]: newValue })
            } else {
                newPersonnel.push(person)
            }
        })
        const newObj = { ...fund, personnel: newPersonnel }
        setFund(newObj)
    }

    function getFormattedDuration(startDate, endDate) {
        if (!startDate || !endDate) {
            return "Could not calculate time in position.";
        }
        const years = differenceInYears(endDate, startDate);
        const totalMonths = differenceInMonths(endDate, startDate);
        const months = totalMonths % 12;

        const duration = {
            years,
            months
        };

        return formatDuration(duration);
    }

    const colWidths = ['18%', 'auto', '240px', 'auto', '350px']
    const headers = ["Name", "Current Position", "Time in Current Position", "Previous/Other Position", "Time in Previous/Other Position"]
    // const headers = editMode
    //     ? ["Name", "Current Position", "Current Position Start Date", "Previous/Other Position", "Previous Position Start Date - End Date"]
    //     : ["Name", "Current Position", "Time in Current Position", "Previous/Other Position", "Time in Previous/Other Position"]

    const personnelDataMap = (data) => data && data.map((person, idx) => {
        const { name, email, currentPosition, previousPosition, currentStartDate, previousYears, previousMonths, /*previousStartDate, previousEndDate,*/ deleted } = person
        const previousPositionDate = `${previousYears === 0 ? "" : previousYears}${previousYears === 1 ? " year" : previousYears === 0 ? "" :" years"} ${previousMonths === 0 ? "" : previousMonths}${previousMonths === 1 ? " month" : previousMonths === 0 ? "" : " months"}`;

        return (
            <>
                <tr key={idx} className='cursor-pointer' onClick={() => null/*changeRoute(ROUTE_PATHS[PAGES.ADMIN] + '/fund-management/funds/' + fund.id)*/}>
                    <td className={`${deleted ? "deleted-personnel" : ""}`}>
                        {/* {editMode && deleted
                            ? <p style={deleted ? { color: "#A0001E", opacity: "0.4" } : {}}>
                                <span>{name}</span>
                                <span>{" (Deleting)"}</span>
                            </p>
                            : editMode
                                ? <DetailField
                                    onClick={(e) => e.stopPropagation()}
                                    variant="bordered-light"
                                    editMode={editMode}
                                    onChange={(e) => updateKeyPersonnel(e.target.value, "name", idx)}
                                    value={name}
                                />
                                : <p>{name}</p>
                        } */}
                        <p>{name}</p>
                    </td>
                    <td className={`${deleted ? "deleted-personnel" : ""}`} >
                        <DetailField
                            variant="bordered-light"
                            editMode={false}//{editMode && !deleted}
                            onChange={(e) => null} //updateKeyPersonnel(e.target.value, "currentPosition", idx)}
                            value={currentPosition}
                            style={editMode && deleted ? { color: "#A0001E", opacity: "0.4" } : null}
                        />
                    </td>
                    <td className={`${deleted ? "deleted-personnel" : ""}`} >
                        {editMode && deleted
                            ? <span style={{ color: "#A0001E", opacity: "0.4" }}>{format(new Date(currentStartDate), "dd/MM/yyyy")}</span>
                            : <DetailField
                                type="date"
                                max={format(new Date(), "yyyy-MM-dd")}
                                variant="bordered-light"
                                editMode={false}//{editMode}
                                onChange={(e) => null} //updateKeyPersonnel(e.target.value, "currentStartDate", idx)}
                                value={getFormattedDuration(new Date(currentStartDate), new Date())}
                                // value={editMode ? currentStartDate : getFormattedDuration(new Date(currentStartDate), new Date())}
                            />
                        }
                    </td>
                    <td className={`${deleted ? "deleted-personnel" : ""}`} >
                        <DetailField
                            variant="bordered-light"
                            editMode={false}//{editMode && !deleted}
                            onChange={(e) => null} //updateKeyPersonnel(e.target.value, "previousPosition", idx)}
                            value={previousPosition}
                            // style={editMode && deleted ? { color: "#A0001E", opacity: "0.4" } : null}
                        />
                    </td>
                    <td className={`${deleted ? "deleted-personnel" : ""}`} >
                        <FlexWrapper justify="space-between">
                            <FlexWrapper gap='s'>
                                {/* {editMode && deleted
                                    ? <span style={{ color: "#A0001E", opacity: "0.4" }}>{format(new Date(previousStartDate), "dd/MM/yyyy")}</span> */}
                                    {/* :  */}
                                    <DetailField
                                        type="date"
                                        max={format(new Date(), "yyyy-MM-dd")}
                                        variant="bordered-light"
                                        editMode={false}//{editMode}
                                        onChange={(e) => null} //{ updateKeyPersonnel(e.target.value, "previousStartDate", idx) }}
                                        value={previousPositionDate}
                                        // value={editMode ? previousStartDate : getFormattedDuration(new Date(previousStartDate), new Date(previousEndDate))}
                                    />
                                {/* } */}
                                {/* {editMode && <span style={deleted ? { color: "#A0001E", opacity: "0.4" } : null}>-</span>}
                                {editMode && deleted
                                    ? <span style={{ color: "#A0001E", opacity: "0.4" }}>{format(new Date(previousEndDate), "dd/MM/yyyy")}</span>
                                    : editMode ? <DetailField
                                        type="date"
                                        max={format(new Date(), "yyyy-MM-dd")}
                                        variant="bordered-light"
                                        editMode={editMode}
                                        onChange={(e) => updateKeyPersonnel(e.target.value, "previousEndDate", idx)}
                                        value={previousEndDate}
                                    /> : ""} */}
                            </FlexWrapper>
                            {/* {editMode || deleted ? <Trash2 className="material-icons" style={deleted ? { color: "#A0001E", opacity: 1 } : { opacity: 0.8 }} onClick={(e) => { e.stopPropagation(); updateKeyPersonnel(!deleted, "deleted", idx) }} /> : ""} */}
                        </FlexWrapper>
                    </td>
                </tr>
            </>
        );
    })

    return (
        <PageGridItem container col="1 / span 12">
            <Table
                minWidth={1400}
                tableStyle={{ maxWidth: 1800 }}
                colWidths={colWidths}
                headers={headers}
                dataMap={personnelDataMap(fund?.personnel)}
                id='fund-personnel-table'
            />
        </PageGridItem>
    );
}

export default FundPersonnel;